import React from "react";
import { ReactComponent as HeroImg } from "../../assets/heroImg.svg";
import { Link, animateScroll as scroll } from "react-scroll";

const Hero = ({ id }) => {
  return (
    <div>
      <section class="text-gray-400 bg-gray-900 body-font">
        <div class="container mx-auto md:w-11/12 flex px-5 py-10 md:py-20 md:flex-row flex-col items-center">
          <div class="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
            <h1 class="font-semibold sm:text-xl md:text-2xl text-2xl mb-4 text-white">
              Hi there, I am Prayash Shrestha
            </h1>
            <p class="mb-8 leading-relaxed text-sm sm:text-sm md:text-xl ">
              Innovative full stack developer with extensive experience skilled
              at building robust, user-friendly solutions to deliver exceptional
              experiences.
            </p>
            <div class="flex justify-center">
              <Link
                to="About"
                smooth={true}
                class="sm:whitespace-nowrap inline-flex text-white bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-500 rounded text-lg"
              >
                About me
              </Link>
              <Link
                to="Projects"
                smooth={true}
                class="sm:whitespace-nowrap ml-4 inline-flex  text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg"
              >
                See my works
              </Link>
            </div>
          </div>
          <div class="md:w-1/2 flex justify-center">
            {/* <HeroImg class='w-full h-1/3 sm:w-3/4 sm:h-2/3 lg:w-full lg:h-auto  object-cover' /> */}
            <HeroImg class="w-3/4 h-3/4 md:w-full md:h-full object-cover" />
            {/* <img
              class='object-cover object-center rounded'
              alt='hero'
              src='https://dummyimage.com/720x600'
            /> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Hero;
